module.exports = __webpack_public_path__ + "static/3-c8e7a7f4d17b5fb1b3c242dfaae97092.jpg";